// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { SLTPTrigger } from '@shared/utils/SlTpTrigger';
import { OffsetModeViewEnum } from '@shared/utils/Trading/OffsetModeViewEnum';
import { OrderEditBaseUtils } from '@shared/utils/Trading/OrderEditBaseUtils';
import { DynProperty } from './DynProperty';
// TODO. Refactor.
export class SLTPDynProperty extends DynProperty {
    constructor(name, group, parentGroup) {
        name = name || OrderEditBaseUtils.SLTP_PARAM;
        super(name, undefined, DynProperty.SLTP, group, parentGroup);
        this.isVisibleOTHTrading = false;
        this.isEnabledOTHTradingSL = false;
        this.isEnabledOTHTradingTP = false;
        this.isAllowOTHTradingSL = null;
        this.isAllowOTHTradingTP = null;
        this.isVisibleEnableButtonSL = true;
        this.sl = {
            increment: 1,
            decimalPlaces: 0,
            minimalValue: 1,
            maximalValue: 999999,
            value: 1,
            enabled: false,
            canEdit: true, // #93540
            Intervals: null,
            error: null,
            inOffset: false,
            offsetType: OffsetModeViewEnum.Ticks
        };
        this.tp = {
            increment: 1,
            decimalPlaces: 0,
            minimalValue: 1,
            maximalValue: 999999,
            value: 1,
            enabled: false,
            Intervals: null,
            error: null,
            inOffset: false,
            offsetType: OffsetModeViewEnum.Ticks
        };
        this.trailingStop = {
            increment: 1,
            decimalPlaces: 0,
            minimalValue: 1,
            maximalValue: 999999,
            value: 1,
            visibleValue: 1,
            enabled: false,
            error: null
        };
        this.slProfit = null;
        this.tpProfit = null;
        this.trailingStopProfit = null;
        this.trailingStopAllowed = false;
        this.sllValueEnabled = false; // #91413
        this.sltpTriggerShort = null; // #109798
        this.nonEditableSLTPTriggerShort = null; // #110640 <- #109798
    }
    triggersVisibleInOE() {
        // по общему правилу комбобокса из Settings
        const sV = this.sltpTriggerShort;
        return sV !== null ? SLTPTrigger.CanSelectInOE(sV) : false;
    }
    triggerVisible(isSL = true) {
        // общее правило + включен ли SL/TP
        return this[isSL ? 'sl' : 'tp'].enabled && this.triggersVisibleInOE();
    }
    SLTriggerVisible() {
        return this.triggerVisible(true);
    }
    TPTriggerVisible() {
        return this.triggerVisible(false);
    }
}
